.wrap {
  position: relative;
  width: 100%;
}
.wrap > input {
  width: 100%;
  /* Right padding leaves room for the absolutely-positioned × button so
     it doesn't overlap the value when the field has one. */
  padding-right: 28px;
}
.clear {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border: 0;
  background: transparent;
  color: var(--text-muted);
  font-size: 1rem;
  line-height: 1;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color var(--t-fast), background var(--t-fast);
}
.clear:hover {
  color: white;
  background: var(--error);
}
